if not App.angularApp?
    return

App.angularApp.directive 'mfError', () ->
    return {
        restrict: 'E'
        require: '^mfErrorsContainer'
        link: (scope, element, attrs) =>
            element.addClass 'control-label'

            form = element.closest('mf-errors-container').attr('form')

            scope.$watch "#{form}.#{attrs.input}.$error.#{attrs.error} && !#{form}.#{attrs.input}.$pristine",
            (showError) =>
                if showError
                    element.show(100)
                else
                    element.hide(100)
    }

###
<p class='animate-show control-label'
    ng-show="settingsForm.company_name.$error.required && !settingsForm.company_name.$pristine">
    Company Name is required
</p>
###
